var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"account-appeal-success"},[_c('img',{attrs:{"src":require("../../assets/img/shensu/success3x.png"),"alt":""}}),(_vm.flag)?_c('p',[_vm._v("申诉成功")]):_c('p',[_vm._v("提交成功，请耐心等待系统审核!")]),_c('div',{on:{"click":_vm.closeWindow}},[_c('span',[_vm._v("关闭页面")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }